import { withRouter, Link, useHistory } from 'react-router-dom';
import images from '../../assets';
import { Button, Drawer, List } from '@material-ui/core';
import MyBadge from '../badge/MyBadge';
import { CartCountBadge } from '../badge/MyCartBadge'
import { useSelector } from 'react-redux';

import {
  TopBar,
} from './TopBar';
import store from '../../store';

export const HeaderMobile = ({overbtn, 
    hideMenu, 
    onOpenGnbMenu, 
    onOpenBasketRightGnbMenu,
    changeState
  }) => {
  const history = useHistory();
  const totalCartCount = useSelector(state => state.getUserInfo.totalCartCount);
  const authdata = localStorage.getItem('userData');
  const { cartCount, aiCartCount } = store.getState();

  const onGoHome = async () => {
    hideMenu();
    history.push('/');
  };

  const onAlarmList = (e) => {
    hideMenu();
    history.push('/mypage/basic/alerms');
  };

  const onGoAuth = () => {
    hideMenu();
    history.push('/auth');
  };


  return  (
    <>
      <>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Link to="#" onClick={onGoHome}>
            <img alt="" src={images.icon_TDB} style={{ marginLeft: 5, height: 30 }} />
          </Link>
        </div>
        
        <Button size="small" style={{ minWidth: 40 }} onClick={onOpenGnbMenu}>
          <img alt="" src={images.gnb_menu} style={{ width: 20, height: 20 }} />
        </Button>

        <div style={{ flex: 1 }} />

        {authdata !== null && (
          <Button size="small" style={{ minWidth: 40 }}>
            <MyBadge onClick={onAlarmList}>
              <img alt="" src={images.topbar_alerm} style={{ width: 26, height: 26 }} />
            </MyBadge>
          </Button>
        )}
        {authdata !== null && (

          <Button size="small" style={{margin:'0px 4px', minWidth: 40 }}>
            <CartCountBadge count={totalCartCount} onClick={onOpenBasketRightGnbMenu}>
              <img alt="" src={images.topbar_basket} style={{ width: 26, height: 26 }} />
            </CartCountBadge>
          </Button>
        )}
        {authdata === null && (
          <Button size="small" style={{ minWidth: 40 }} onClick={onGoAuth}>
            <img alt="" src={images.topbar_login} style={{ width: 26, height: 26 }} />
          </Button>
        )}
        {authdata !== null && (
          <Button onClick={()=>{
            console.log('headermob');
            changeState('overbtn', overbtn === 'mypagedraweropen' ? '' : 'mypagedraweropen')
          }} size="small" style={{ minWidth: 40 }}>
            <img
              alt=""
              src={
                store.getState().profile_img
                  ? `${process.env.REACT_APP_S3_BUCKET_DOMAIN}${store.getState().profile_img}`
                  : images.topbar_avatar
              }
              style={{ width: 30, height: 30, borderRadius: 15 }}
            />
          </Button>
        )}
      </>
     
    </>
  );
};